<template>
  <div>
    <b-row class="mb-1">
      <b-col cols="9" />
      <b-col cols="3">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          block
          variant="relief-primary"
          @click="editGeneration"
        >
          <feather-icon
            size="18"
            icon="EditIcon"
            class="mr-1"
          />
          {{ setTextButton(isEdit) }}
        </b-button>
      </b-col>
    </b-row>
    <vue-good-table
      :columns="columns"
      :rows="data"
      :total-rows="total"
      :line-numbers="false"
      :fixed-header="false"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >
        <div v-if="props.column.field === 'formacionInicial'">
          <b-avatar :variant="getColor(props.row.formacion_inicial)">
            <feather-icon :icon="getStatus(props.row.formacion_inicial)" />
          </b-avatar>
        </div>

        <div v-else-if="props.column.field === 'evaluacionAcademica'">
          <div v-if="isEdit">
            <b-form-group
              :label-for="`input-valid-${props.row.id}`"
              size="sm"
            >
              <b-form-input
                :id="`input-valid-${props.row.id}`"
                v-model="props.row.evaluacion_academica"
                v-maska="['##.##', '#.##', '#', '##']"
                placeholder="Calificación"
                @keyup="
                  () => {
                    const value = parseFloat(props.row.evaluacion_academica)
                    const EVALUACION = 0
                    update(
                      props.row.id,
                      {
                        evaluacion_academica: value,
                      },
                      value,
                      EVALUACION,
                    )
                  }
                "
              />
            </b-form-group>
          </div>
          <span
            v-else
          ><strong>{{
            getEvaluation(props.row.evaluacion_academica)
          }}</strong></span>
        </div>

        <div v-else-if="props.column.field === 'horas'">
          <div v-if="isEdit">
            <b-form-group
              :label-for="`horas-${props.row.id}`"
              size="sm"
            >
              <b-form-input
                :id="`input-horas-${props.row.id}`"
                v-model="props.row.horas"
                v-maska="['###', '##', '#']"
                placeholder="horas"
                @keyup="
                  () => {
                    const value = parseInt(props.row.horas)
                    const HORAS = 1
                    update(
                      props.row.id,
                      {
                        horas: value,
                      },
                      value,
                      HORAS,
                    )
                  }
                "
              />
            </b-form-group>
          </div>
          <span
            v-else
          ><strong>{{ getHoras(props.row.horas) }}</strong></span>
        </div>

        <div v-else-if="props.column.field === 'fechaInicio'">
          <div v-if="isEdit">
            <b-form-group
              :label-for="`inicio-${props.row.id}`"
              size="sm"
            >
              <b-form-input
                :id="`cleave-inicio-${props.row.id}`"
                v-model="props.row.fecha_inicio"
                v-maska="'####-##-##'"
                placeholder="YYYY-MM-DD"
                @keyup="
                  () => {
                    const value = props.row.fecha_inicio
                    const FECHA = 2
                    update(
                      props.row.id,
                      {
                        fecha_inicio: value,
                      },
                      value,
                      FECHA,
                    )
                  }
                "
              />
            </b-form-group>
          </div>
          <span
            v-else
          ><strong>{{ getFecha(props.row.fecha_inicio) }}</strong></span>
        </div>

        <div v-else-if="props.column.field === 'fechaTermino'">
          <div v-if="isEdit">
            <b-form-group
              :label-for="`termino-${props.row.id}`"
              size="sm"
            >
              <b-form-input
                :id="`cleave-termino-${props.row.id}`"
                v-model="props.row.fecha_termino"
                v-maska="'####-##-##'"
                placeholder="YYYY-MM-DD"
                @keyup="
                  () => {
                    const value = props.row.fecha_termino
                    const FECHA = 2
                    update(
                      props.row.id,
                      {
                        fecha_termino: value,
                      },
                      value,
                      FECHA,
                    )
                  }
                "
              />
            </b-form-group>
          </div>
          <span
            v-else
          ><strong>{{ getFecha(props.row.fecha_termino) }}</strong></span>
        </div>

        <div v-else-if="props.column.field === 'action'">
          <b-button
            variant="falt"
            size="sm"
            :disabled="isEdit"
            @click="
              $router.push({
                name: 'generacion-becario-detalle',
                params: {
                  id: props.row.prebecario_id,
                  idBecario: props.row.id,
                  curp: props.row.curp,
                  mode: false,
                },
              })
            "
          >
            <feather-icon
              :id="`invoice-row-${props.row.curp}-preview-icon`"
              icon="EyeIcon"
              size="16"
              class="mx-1"
            />
            <span>Detalles</span>
          </b-button>
          <b-button
            variant="falt"
            size="sm"
            :disabled="true"
            @click="
              $router.push({
                name: 'generacion-becario-detalle',
                params: {
                  id: props.row.prebecario.id,
                  idBecario: props.row.id,
                  curp: props.row.prebecario.curp,
                  mode: false,
                },
              })
            "
          >
            <feather-icon
              :id="`invoice-row-${props.row.curp}-preview-icon`"
              icon="SendIcon"
              size="16"
              class="mx-1"
            />
            <span>Adscripción</span>
          </b-button>
        </div>
      </template>

      <div
        slot="emptystate"
        class="text-center"
      >
        No hay datos para mostrar.
      </div>
      <div
        slot="loadingContent"
        class="text-center"
      >
        <span class="vgt-loading__content"> cargando registros... </span>
      </div>
    </vue-good-table>
  </div>
</template>

<script>
import {
  BAvatar,
  BButton,
  BFormGroup,
  BFormInput,
  BCol,
  BRow,
} from 'bootstrap-vue'
// import Cleave from 'vue-cleave-component'

import _ from 'lodash'
import { maska } from 'maska'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
// import moment from 'moment'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import BecariosService from '@/services/BecariosService'

export default {
  directives: {
    maska,
    Ripple,
  },
  components: {
    BAvatar,
    BButton,
    BFormGroup,
    BFormInput,
    BCol,
    BRow,
    // Cleave,
    VueGoodTable,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isEdit: false,
      becarios: [],
      total: 0,
      test: null,
      date: {
        date: true,
        delimiter: '-',
        datePattern: ['Y', 'm', 'd'],
      },
      columns: [
        // { label: 'id', field: 'id' },
        { label: 'CURP', field: 'curp' },
        {
          label: 'Formación Inicial',
          field: 'formacionInicial',
          tdClass: 'text-center',
        },
        {
          label: 'Evaluación Academica',
          field: 'evaluacionAcademica',
          tdClass: 'text-center',
        },
        {
          label: 'Horas',
          field: 'horas',
          tdClass: 'text-center',
        },
        {
          label: 'Fecha Inicio',
          field: 'fechaInicio',
          tdClass: 'text-center',
        },
        {
          label: 'Fecha Termino',
          field: 'fechaTermino',
          tdClass: 'text-center',
        },
        { label: 'Acciones', field: 'action', sortable: false },
      ],
    }
  },
  computed: {
    getStatus() {
      return status => (status ? 'CheckSquareIcon' : 'XSquareIcon')
    },
    getColor() {
      return status => (status ? 'success' : 'danger')
    },
    getFecha() {
      return fecha => fecha || 'Sin fecha'
    },
    getHoras() {
      return horas => horas || 'Sin horas'
    },
    getEvaluation() {
      return evaluation => evaluation || 'Sin evaluación'
    },
    setTextButton() {
      return edit => (!edit ? 'editar generación' : 'finalizar edición')
    },
    statusAdscripcion() {
      return status => (!status ? 'enviar adscripcion' : 'en adscripcion')
    },
    getUltimaCompetencia() {
      return null
    },
    msg() {
      return text => this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Error!',
          icon: 'AlertTriangleIcon',
          text,
          variant: 'danger',
        },
      })
    },
  },
  created() {
    this.update = _.debounce(this.update, 1000)
  },
  mounted() {
    this.isEdit = false
    // this.becarios = [...this.data]
  },
  methods: {
    editGeneration() {
      this.isEdit = !this.isEdit
      if (!this.isEdit) {
        this.$emit('update-list')
      }
    },
    update(id, data, value, type) {
      const EVALUACION = 0
      const HORAS = 1
      const FECHA = 2
      if (type === EVALUACION) {
        if (value && value !== '' && value >= 0 && value <= 10) {
          this.updateDataBecario(id, data)
        } else {
          this.msg('Calificación no valida! Intenta de nuevo por favor')
        }
      }
      if (type === HORAS) {
        if (value > 0 && value < 999) {
          this.updateDataBecario(id, data)
        } else {
          this.msg('Horas no validos! Intenta de nuevo por favor')
        }
      }
      if (type === FECHA) {
        this.updateDataBecario(id, data)
      }
    },
    updateDataBecario(id, data) {
      BecariosService.setData(id, data)
    },
  },
}
</script>

<style></style>
